import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withJobtrackDefaultRoute } from './withJobtrackDefaultRoute';
import ChemHeader from '../ChemHeader';
import Confirm from '../Confirm';
import TreeMenu from '../TreeMenu';
import Restricted from '../Restricted';
import Help from './Help';
import Home from './Home';
import Request from './Request';
import Requests from './Requests';
import Jobs from './Jobs';
import Job from './Job';
import Unassigned from './Unassigned';
import Parts from './Parts';
import Part from './Part';
import Projects from './Projects';
import Project from './Project';
import LaborMaterial from './LaborMaterial';
import Labor from './Labor';
import Material from './Material';
import PartSignOut from './PartSignOut';
import Billing from './Billing';
import Employees from './Employees';
import Shops from './Shops';
import Categories from './Categories'
import MarkUpRates from './MarkUpRates';
import AdHocReport from './AdHocReport';
import StudentShopUpload from './StudentShopUpload';

class Jobtrack extends ChemComponent {
  	constructor(props) {
		super(props);

		this.state = {
			fullScreen: false,
			menuWidth: 2,
			treeMenuItems: this.filterTreeMenuItems(props.user),
			jobEditable: false,
			partEditable: false,
			projectEditable: false,
			linkJobProject: {
				JOB_ID: null,
				PROJECT_ID: null
			},
			confirm: ''
		};
	}
		
	componentDidUpdate(prevProps) {
		// if permissions have been populated
		if (!this.objectsAreEqual(prevProps.user, this.props.user)) {
			// update user in state
			this.mergeStateWithArrays({
				treeMenuItems: this.filterTreeMenuItems(this.props.user)
			});
		}
	}
	
	filterTreeMenuItems(user) {
		// copy menu items so we can edit
		var filteredTreeMenuItems = this.copyTreeMenuItems(treeMenuItems);
		
		// if the user is not authorized in any way
		if (!user.jobtrack || user.jobtrack.authLevel < 1) {
			// remove everything except request and request list
			this.removeRoute(filteredTreeMenuItems, routes.home);
			this.removeRoute(filteredTreeMenuItems, routes.newJob);
			this.removeRoute(filteredTreeMenuItems, routes.jobs);
			this.removeRoute(filteredTreeMenuItems, routes.newProject);
			this.removeRoute(filteredTreeMenuItems, routes.projects);
			this.removeRoute(filteredTreeMenuItems, routes.laborMaterial);
			this.removeRoute(filteredTreeMenuItems, routes.parts);
			this.removeRoute(filteredTreeMenuItems, routes.employees);
			this.removeRoute(filteredTreeMenuItems, routes.shops);
			this.removeRoute(filteredTreeMenuItems, routes.categories);
			this.removeRoute(filteredTreeMenuItems, routes.billing);
			this.removeRoute(filteredTreeMenuItems, routes.adhoc);
			this.removeRoute(filteredTreeMenuItems, routes.markup);
			this.removeRouteByLabel(filteredTreeMenuItems, 'Non Transf. Material');
			this.removeRouteByLabel(filteredTreeMenuItems, 'Jobs to Bill');
			this.removeRoute(filteredTreeMenuItems, routes.sstupload);
		}
		
		return filteredTreeMenuItems;
	}
	
	setMenuWidth(newWidth) {
		if (newWidth > 12) newWidth = 12;
		else if (newWidth < 1) newWidth = 1;
		
		this.mergeState({
			menuWidth: newWidth,
			renderKey: this.state.renderKey + 1
		});
	}

	removeRoute(menuItems, route) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				this.removeRoute(menuItems[i].nodes, route);
				if (menuItems[i].nodes.length === 0) {
					menuItems.splice(i--, 1);
				}
			} else {
				if (menuItems[i].route && menuItems[i].route.toUpperCase() === route.toUpperCase()) {
					menuItems.splice(i--, 1);
				}
			}
		}
	}
	
	removeRouteByLabel(menuItems, label) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				this.removeRouteByLabel(menuItems[i].nodes, label);
				if (menuItems[i].nodes.length === 0) {
					menuItems.splice(i--, 1);
				}
			} else {
				if (menuItems[i].label && menuItems[i].label.toUpperCase() === label.toUpperCase()) {
					menuItems.splice(i--, 1);
				}
			}
		}
	}
	
	showConfirmation(message) {
		var self = this;
		this.mergeState({
			confirm: message
		}, () => self.props.navigate('/Jobtrack/Confirm'));
	}
	
	toggleFullScreen(fullScreen) {
		this.mergeState({ fullScreen: fullScreen });
	}

	render() {
		return (<>
			<ChemHeader parent={this} user={this.props.user} title='Jobtrack' fullScreen={this.state.fullScreen} 
				toggleFullScreen={(fullScreen) => this.toggleFullScreen(fullScreen)}
				showHelp={() => this.props.navigate('/Jobtrack/Help', { helpPath: this.props.location.pathname })} />
			<Container fluid style={{ paddingTop: 20, paddingBottom: 20, backgroundColor: '#e6e6e4', height: 'calc(100vh - 64px)', overflow: 'auto' }}>
				<Row>
					{!this.state.fullScreen && <Col xs={this.state.menuWidth}>
						<TreeMenu parent={this} menuItems={this.state.treeMenuItems} selectedRoute={this.props.location.pathname} />
					</Col>}
					<Col xs={this.state.fullScreen ? 12 : (12 - this.state.menuWidth)}>
					  <main id='main'>
						<Routes>
							<Route path={'/request'} element={<Request parent={this} user={this.props.user} />} />
							<Route path={'/requests'} element={<Requests parent={this} user={this.props.user} />} />
							<Route path={'/home'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Home parent={this} user={this.props.user} />
								</Restricted>
							} />								
							<Route path={'/jobs'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Jobs parent={this} user={this.props.user} setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} />
								</Restricted>
							} />
							<Route path={'/jobs/new'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Job parent={this} user={this.props.user} editable={true} linkJobProject={(jobId, projectId) => 
										this.mergeState({ linkJobProject: { JOB_ID: jobId, PROJECT_ID: projectId }})} />
								</Restricted>	
							} />
							<Route path={'/jobs/new/:activeTab'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Job parent={this} user={this.props.user} editable={true} linkJobProject={(jobId, projectId) => 
										this.mergeState({ linkJobProject: { JOB_ID: jobId, PROJECT_ID: projectId }})} />
								</Restricted>
							} />
							<Route path={'/jobs/:jobId'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Job parent={this} user={this.props.user} editable={this.state.jobEditable} linkJobProject={(jobId, projectId) => 
										this.mergeState({ linkJobProject: { JOB_ID: jobId, PROJECT_ID: projectId }})} />
								</Restricted>
							} />
							<Route path={'/jobs/:jobId/:activeTab'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Job parent={this} user={this.props.user} editable={this.state.jobEditable} linkJobProject={(jobId, projectId) => 
										this.mergeState({ linkJobProject: { JOB_ID: jobId, PROJECT_ID: projectId }})} />
								</Restricted>
							} />
							<Route path={'/unassigned'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Unassigned parent={this} user={this.props.user} setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} />
								</Restricted>
							} />
							<Route path={'/parts'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Parts parent={this} user={this.props.user} setPartEditable={(partEditable) =>
										this.mergeState({ partEditable: partEditable })} />
								</Restricted>
							} />
							<Route path={'/parts/new'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Part parent={this} user={this.props.user} editable={true} />
								</Restricted>	
							} />
							<Route path={'/parts/:partId'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Part parent={this} user={this.props.user} editable={this.state.partEditable} />
								</Restricted>
							} />
							<Route path={'/projects'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Projects parent={this} user={this.props.user} setProjectEditable={(projectEditable) =>
										this.mergeState({ projectEditable: projectEditable })} />
								</Restricted>
							} />
							<Route path={'/projects/new'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Project parent={this} user={this.props.user} editable={true} setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} linkJobProject={(jobId, projectId) => 
										this.mergeState({ linkJobProject: { JOB_ID: jobId, PROJECT_ID: projectId }})} />
								</Restricted>	
							} />
							<Route path={'/projects/new/:activeTab'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Project parent={this} user={this.props.user} editable={true} setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} linkJobProject={(jobId, projectId) => 
										this.mergeState({ linkJobProject: { JOB_ID: jobId, PROJECT_ID: projectId }})} />
								</Restricted>
							} />
							<Route path={'/projects/:projectId'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Project parent={this} user={this.props.user} editable={this.state.projectEditable} setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} linkJobProject={(jobId, projectId) => 
										this.mergeState({ linkJobProject: { JOB_ID: jobId, PROJECT_ID: projectId }})} />
								</Restricted>
							} />
							<Route path={'/projects/:projectId/:activeTab'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Project parent={this} user={this.props.user} editable={this.state.projectEditable} setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} linkJobProject={(jobId, projectId) => 
										this.mergeState({ linkJobProject: { JOB_ID: jobId, PROJECT_ID: projectId }})} />
								</Restricted>
							} />
							<Route path={'/labormaterial'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<LaborMaterial parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/labor/:shopId'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Labor parent={this} user={this.props.user} setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} />
								</Restricted>
							} />
							<Route path={'/material/:shopId'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Material parent={this} user={this.props.user} setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} />
								</Restricted>
							} />
							<Route path={'/partsignout/:shopId'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<PartSignOut parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/billing'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Billing parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/employees'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Employees parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/shops'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Shops parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/categories'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<Categories parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/markuprates'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<MarkUpRates parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/adhocreport'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<AdHocReport parent={this} user={this.props.user}
										setJobEditable={(jobEditable) =>
										this.mergeState({ jobEditable: jobEditable })} />
								</Restricted>
							} />
							<Route path={'/studentshopupload'} element={
								<Restricted authorized={this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 0}>
									<StudentShopUpload parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/confirm'} element={<Confirm parent={this} user={this.props.user} message={this.state.confirm} />} />
							<Route path={'/help'} element={<Help parent={this} user={this.props.user} />} />
						</Routes>
					  </main>
					</Col>
				</Row>
			</Container>
		</>);
	}
}

// routes defined here so there are no accidents when removing them!
const routes = {
	adhoc: '/Jobtrack/AdHocReport',
	billing: '/Jobtrack/Billing',
	categories: '/Jobtrack/Categories',
	employees: '/Jobtrack/Employees',
	home: '/Jobtrack/Home',
	jobs: '/Jobtrack/Jobs',
	laborMaterial: '/Jobtrack/LaborMaterial',
	markup: '/Jobtrack/MarkUpRates',
	newJob: '/Jobtrack/Jobs/new',
	newProject: '/Jobtrack/Projects/new',
	parts: '/Jobtrack/Parts',
	projects: '/Jobtrack/Projects',
	request: '/Jobtrack/Request',
	requests: '/Jobtrack/Requests',
	shops: '/Jobtrack/Shops',
	sstupload: '/Jobtrack/StudentShopUpload',
	unassigned: '/Jobtrack/Unassigned'
};

const treeMenuItems = [
	{
		label: 'Home',
		route: routes.home
	},
	{
		label: 'Enter Request',
		route: routes.request
	},
	{
		label: 'Reported Requests',
		route: routes.requests
	},
	{
		label: 'New Job',
		route: routes.newJob
	},
	{
		label: 'Job List',
		route: routes.jobs
	},
	{
		label: 'Unassigned Jobs',
		route: routes.unassigned
	},
	{
		label: 'New Project',
		route: routes.newProject
	},
	{
		label: 'Project List',
		route: routes.projects
	},
	{
		label: 'Labor & Material',
		route: routes.laborMaterial
	},
	{
		label: 'Report Menu',
		nodes: [
			{
				label: 'Ad Hoc Report',
				route: routes.adhoc
			},
			{
				label: 'Non Transf. Material',
				action: '/Jobtrack/NonTransferredMaterial',
				data: {
					__RequestVerificationToken: null,
					shopid: null
				}
			},
			{
				label: 'Jobs to Bill',
				action: '/Home/Pdf',
				data: {
					__RequestVerificationToken: null,
					title: 'Non Transferred Charges',
					columns: [
						{ Header: 'Job', accessor: 'JOB_ID', width: 12 },
						{ Header: 'Desc', accessor: 'DESCRIPTION', width: 60 },
						{ Header: 'Entered', accessor: 'DATE_ENTERED', width: 25 },
						{ Header: 'Customer', accessor: 'CUSTOMER', width: 40 },
						{ Header: 'PI', accessor: 'PI', width: 40 },
						{ Header: 'Estim. Material', accessor: 'ESTIMATED_MAT', width: 14 },
						{ Header: 'Total Material', accessor: 'TOTAL_MAT', width: 14 },
						{ Header: 'Billed Material', accessor: 'TOTAL_BILLED_MAT', width: 14 },
						{ Header: 'Not Transf. Material', accessor: 'TOTAL_NOT_TRANSF_MAT', width: 14 },
						{ Header: 'Estim. Labor', accessor: 'ESTIMATED_LABOR', width: 14 },
						{ Header: 'Total Labor', accessor: 'TOTAL_LABOR', width: 14 },
						{ Header: 'Billed Labor', accessor: 'TOTAL_BILLED_LABOR', width: 14 },
						{ Header: 'Not Transf. Labor', accessor: 'TOTAL_NOT_TRANSF_LABOR', width: 14 }
					],
					entity: 'RECHARGES.JOBS_TO_BILL_VW',
					order: 'JOB_ID'
				}
			}
		]
	},
	{
		label: 'Admin',
		nodes: [
			{
				label: 'Employees',
				route: routes.employees
			},
			{
				label: 'Shops',
				route: routes.shops
			},
			{
				label: 'Material Parts',
				route: routes.parts
			},
			{
				label: 'Material Categories',
				route: routes.categories
			},
			{
				label: 'Billing',
				route: routes.billing
			},
			{
				label: 'Shops Mark Up Rate',
				route: routes.markup
			},
			{
				label: 'Student Shop Training Upload',
				route: routes.sstupload
			}
		]
	}
];

export default withJobtrackDefaultRoute(Jobtrack);
